import { type FC, useCallback, useEffect, useMemo, useState } from "react";

const PATTERNS = {
  small: ["⠟", "⠯", "⠷", "⠾", "⠽", "⠻"],
  large: ["⡿", "⣟", "⣯", "⣷", "⣾", "⣽", "⣻", "⢿"],
};

export interface TextSpinnerProps {
  size?: "small" | "large";
}

export const TextSpinner: FC<TextSpinnerProps> = (props) => {
  const [text, setText] = useState("");
  const frames = useMemo(() => (props.size === "large" ? PATTERNS.large : PATTERNS.small), [props.size]);

  const getTextFrame = useCallback(
    (index: number) => {
      return frames[index];
    },
    [frames],
  );

  useEffect(() => {
    let i = 0;

    const interval = setInterval(() => {
      setText(getTextFrame(i));
      i = (i + 1) % frames.length;
    }, 100);

    return () => clearInterval(interval);
  }, [frames, getTextFrame]);

  return text;
};
